// DS: DS6.1 - Link semantics
import React from 'react';
import omit from 'lodash/omit';
import PlainButtonOrLink, {
  Props as PlainButtonOrLinkProps,
} from '../../../../Buttons/PlainButtonOrLink';
import { setRef } from '../../../../../utils/refHelpers';
import { CommonListItemAPI, EffectStrength, useListItem } from '../../common';
import ListItemContent from '../../legos/ListItemContent';

export interface Props
  extends Omit<PlainButtonOrLinkProps, 'prefix' | 'innerRef'>,
    CommonListItemAPI {
  href: string;
}

const ListItemLink: React.FC<Props> = unfilteredProps => {
  const { rootProps, contentProps, ref } = useListItem(unfilteredProps, {
    hover: EffectStrength.Strong,
  });

  return (
    <PlainButtonOrLink
      innerRef={node => setRef(ref, node)}
      {...omit(rootProps, ['disabled', 'checked'])}
    >
      <ListItemContent {...contentProps} />
    </PlainButtonOrLink>
  );
};

ListItemLink.displayName = 'ListItemLink';

export default ListItemLink;
